module.exports = __webpack_public_path__ + "img/274309029_959045814980402_8145325850593954513_n.4797ab25.jpg";